export const calcRating = (currentRating) => {
    return (currentRating / 5) * 100;
}